import { useEffect, useState } from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';
import { useTranslations } from 'use-intl';

import {
  resolveConcurrentSessionChoice,
  subscribeToConcurrentSessionPrompt,
} from '../../../services/concurrentSessionBridge';

// VAPT #15 (Concurrent User): shown when a request comes back with the CONCURRENT_SESSION 409 —
// this account is already active in another session. Mounted once at the app root; visibility is
// driven by concurrentSessionBridge rather than a prop, since the trigger (an axios interceptor)
// isn't a React component and has no parent to lift state into.
const ConcurrentSessionDialog = () => {
  const t = useTranslations('ui');
  const [open, setOpen] = useState(false);

  useEffect(() => subscribeToConcurrentSessionPrompt(setOpen), []);

  return (
    <Dialog open={open} disableEscapeKeyDown maxWidth='xs' fullWidth>
      <DialogTitle>{t('concurrentSessionDialog.title')}</DialogTitle>
      <DialogContent>
        <DialogContentText>
          {t('concurrentSessionDialog.description')}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => resolveConcurrentSessionChoice('cancel')}>
          {t('concurrentSessionDialog.keepOther')}
        </Button>
        <Button variant='contained' onClick={() => resolveConcurrentSessionChoice('take-over')}>
          {t('concurrentSessionDialog.continueHere')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConcurrentSessionDialog;
